<template>
  <div class="py-2">
    <label :for="forLabel()" class="block text-sm text-gray-700">
      <span v-if="required" class="text-rose-600">*</span> {{ label }}
    </label>
    <div class="mt-1">
      <textarea 
        :value="value" 
        @input="onInput" 
        :placeholder="placeholder" 
        :disabled="disabled" 
        :rows="currentRows" 
        class="defaultInput" 
        :style="{ color: textColor }"
        :class="name ? fieldsError[field_id] ? 'bg-rose-50' : '' : ''"
        ref="textarea"
      ></textarea>
      <p v-if="error" class="mt-2 text-sm text-rose-600">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputText",
  props: {
    rows: {
      type: Number,
      default: 3,
    },
    autoGrow: {
      type: Boolean,
      default: false,
    },
    maxRows: {
      type: Number,
      default: 10,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    field_id: {
      type: [String, Number],
      required: false,
    },
    value: [String, Object, Boolean, Number],
    placeholder: String,
    disabled: Boolean,
    error: String,
    fieldsError: {
      type: Object,
      required: false,
    },
    textColor: { // Nova prop para cor do texto
      type: String,
      default: "#000", // Valor padrão: preto
    },
  },
  data() {
    return {
      currentRows: this.rows
    };
  },
  methods: {
    updateValue(event) {
      if (this.field_id) {
        this.$emit("update:modelValue", {
          value: event.target.value,
          field_id: this.field_id,
          label: this.label,
        });
      } else {
        this.$emit("update:modelValue", event.target.value);
      }
    },
    onInput(event) {
      this.updateValue(event);
      
      if (this.autoGrow) {
        this.adjustHeight();
      }
    },
    adjustHeight() {
      const textarea = this.$refs.textarea;
      if (!textarea) return;
      
      // Reset height to calculate scroll height correctly
      textarea.style.height = 'auto';
      
      // Calculate line height based on current font size
      const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight) || 20;
      
      // Calculate number of rows based on scrollHeight
      const newRows = Math.min(
        Math.max(this.rows, Math.ceil(textarea.scrollHeight / lineHeight)),
        this.maxRows
      );
      
      this.currentRows = newRows;
      
      // Apply new height
      textarea.style.height = (newRows * lineHeight) + 'px';
    },
    forLabel() {
      return this.label ? this.label.replace(/\s/g, "").toLowerCase() : "";
    },
  },
  created() {
    if (this.field_id) {
      this.$emit("update:modelValue", {
        value: this.value,
        field_id: this.field_id,
        label: this.label,
      });
    } else {
      this.$emit("update:modelValue", this.value);
    }
  },
  mounted() {
    if (this.autoGrow && this.value) {
      this.$nextTick(() => {
        this.adjustHeight();
      });
    }
  },
  watch: {
    value() {
      if (this.autoGrow) {
        this.$nextTick(() => {
          this.adjustHeight();
        });
      }
    }
  }
};
</script>
